import rootReducer from './reducerChain';

export default rootReducer;